import { SettingsPerCurrency } from '../types';

type tournamentPrize = {
  tournamentPrize: string;
  tournamentCurrency: string;
};

export const getTournamentPrizeByCurrency = (
  settingsPerCurrency: SettingsPerCurrency[] | undefined,
  currentCurrency: string
): tournamentPrize => {
  if (!settingsPerCurrency || !settingsPerCurrency?.length) {
    return {
      tournamentPrize: '',
      tournamentCurrency: ''
    };
  }

  const currentCurrencyConfig = settingsPerCurrency.find(
    ({ currency }) => currency === currentCurrency
  );

  return {
    tournamentPrize:
      currentCurrencyConfig?.tournamentPrize ||
      settingsPerCurrency[0].tournamentPrize ||
      '',
    tournamentCurrency:
      currentCurrencyConfig?.currency || settingsPerCurrency[0].currency || ''
  };
};
